import { Injectable } from '@angular/core';
import { PendingSessionsService } from './pending-sessions.service';
import { ThemeService } from './theme.service';
import { MachineListService } from './machine-list.service';
import { WebRtcService } from './webrtc.service';

@Injectable({
  providedIn: 'root',
})
export class ProviderService {
  constructor(
    private pendingSessionsServiceInstance: PendingSessionsService,
    private webRtcServiceInstance: WebRtcService,
    private themeServiceInstance: ThemeService, 
    private machineListServiceInstance: MachineListService
  ) {}

  get machineListService(): MachineListService {
    return this.machineListServiceInstance;
  }

  get pendingSessionsService(): PendingSessionsService {
    return this.pendingSessionsServiceInstance;
  }

  get webRtcService(): WebRtcService {
    return this.webRtcServiceInstance;
  }

  get themeService(): ThemeService {
    return this.themeServiceInstance;
  }
}
